import React, { useState } from 'react';
import { TextField, Button, Container, Box, Typography, Grid, Alert } from '@mui/material';
import { toast, ToastContainer } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css'; 

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');



  const handleLogin = async (e) => {
    e.preventDefault();
    
    if (!email || !password) {
      setError('Please enter both email and password.');
      toast.error('Please enter both email and password.');
      return;
    }
    
    setError('');
    setLoading(true);
  
    try {
      const formData = new URLSearchParams();
      formData.append('identifier', email);
      formData.append('password', password);
  
      const response = await fetch('https://gracioussacco.co.ke/gracious/api/auth.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded', 
        },
        body: formData.toString(), 
      });
  
      const data = await response.json();
  
      if (data.success) {
        setSuccessMessage(data.message);
        setError('');
  
        localStorage.setItem('user_id', data.user.user_id); 
        localStorage.setItem('role_id', data.user.role_id); 
  
        const roleId = data.user.role_id;

  
        if (roleId === 1) {
          toast.success(data.message);
          localStorage.setItem('isAdmin', 'true'); 
          localStorage.setItem('isLoggedIn', 'true'); 
          window.location.reload();
        } else if (roleId === 2) {
          toast.success(data.message);
          localStorage.setItem('isAdmin', 'false'); 
          localStorage.setItem('isLoggedIn', 'true'); 
          window.location.reload();
        } else {
          toast.error('No access');
          console.log('No access: Role is neither 1 nor 2');
        }
      } else {
        throw new Error(data.message || 'Unknown error occurred.');
      }
    } catch (err) {
      setError(err.message);
      toast.error(err.message);  // Show error toast
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  
  
  

  return (
    <Container
      maxWidth="xs"
      style={{
        paddingTop: '64px',
        paddingBottom: '64px',
      }}
    >
      <Box
        style={{
          textAlign: 'center',
          padding: '32px',
          borderRadius: '8px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          backgroundColor: '#ffffff',
        }}
      >
        {/* Logo */}
        <img
          src="/logo.PNG"
          alt="Logo"
          style={{
            width: '120px',
            marginBottom: '24px',
          }}
        />

        <Typography variant="h5" gutterBottom>
          Login to Gracious Sacco
        </Typography>

        {/* {error && (
          <Alert
            severity="error"
            style={{
              marginBottom: '16px',
            }}
          >
            {error}
          </Alert>
        )} */}

        {/* {successMessage && (
          <Alert
            severity="success"
            style={{
              marginBottom: '16px',
            }}
          >
            {successMessage}
          </Alert>
        )} */}

        <form onSubmit={handleLogin}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Email/Phone/Member No"
                variant="outlined"
                fullWidth
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Password"
                variant="outlined"
                type="password"
                fullWidth
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={loading}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                fullWidth
                variant="contained"
                style={{
                  marginTop: '24px',
                  backgroundColor: '#6a11cb',
                  color: '#fff',
                  fontWeight: 'bold',
                  borderRadius: '8px',
                  padding: '12px 16px',
                }}
                type="submit"
                disabled={loading}
              >
                {loading ? 'Logging in...' : 'Login'}
              </Button>
            </Grid>
          </Grid>
        </form>
      </Box>

      {/* Toast notifications container */}
      <ToastContainer />
    </Container>
  );
};

export default LoginPage;
